module.exports = __webpack_public_path__ + "static/media/logo.543f3389.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FloatingHeader/logo.svg
// module id = 1739
// module chunks = 0